<template>
  <span>
    <v-btn outlined color="primary" :disabled="disabled" @click="showDialog = true">{{$t('book/issue:cancel-task')}}</v-btn>
    <v-dialog v-model="showDialog" persistent width="unset" hide-overlay>
      <v-card class="pa-0">
        <v-card-title class="headline">{{ $t('book/issue:common.cancel-task') }}</v-card-title>
        <v-card outlined class="ma-5 reason-dialog" >
          <v-card-text>
            <v-form ref="form">
              <p>{{ $t('book/issue:common.please-select-reason') }}</p>
              <v-select
                :items="reasonList"
                v-model="reason"
                item-text="label"
                item-value="code"
                :rules="[ruleRequired($t('utils:rules.required'))]"
                />
            </v-form>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="close"
            >{{$t('buttons:cancel')}}
          </v-btn>
          <v-btn
            color="error"
            @click="send"
            >{{$t('buttons:send')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>
<script >
import reasonList from '@/modules/book/views/task/reason-list';
import {ruleRequired} from '@/modules/core/services/rules';

export default {
  name: 'ReasonButton',
  props: {
    disabled: Boolean
  },
  data() {
    return {
      showDialog: false,
      reason: ''
    }
  },
  computed: {
    reasonList() {
      return reasonList;
    }
  },
  methods: {
    ruleRequired,
    close() {
      this.showDialog = false;
      this.reason = '';
    },
    send() {
      if (!this.$refs.form.validate()) {
        document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
        return;
      }

      this.$emit('cancelTask', this.reason);
    }
  }
}
</script>

<style lang="scss">
  .v-card.reason-dialog {
    border: none;
    min-width: 400px;
  }
</style>